import { render, staticRenderFns } from "./ApprovalLevel1.vue?vue&type=template&id=5d5b4d5c"
import script from "./ApprovalLevel1.vue?vue&type=script&lang=js"
export * from "./ApprovalLevel1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports